module.exports = __webpack_public_path__ + "static/media/shape_ice.b718b374.svg";